import { generateApiKeyWithTimestamp } from "../utils/api-key-generator";

/**
 * Creates headers with dynamic X-API-KEY and X-TIMESTAMP
 * Replaces the static X_API_KEY approach
 * @returns Headers object with x-api-key and X-TIMESTAMP
 */
export const createApiHeaders = () => {
  const { apiKey, timestamp } = generateApiKeyWithTimestamp();
  
  return {
    "x-api-key": apiKey,
    "X-TIMESTAMP": timestamp,
  };
};

/**
 * Creates headers with custom timestamp
 * @param customTimestamp - Custom timestamp string
 * @returns Headers object with x-api-key and X-TIMESTAMP
 */
export const createApiHeadersWithTimestamp = (customTimestamp: string) => {
  const { apiKey } = generateApiKeyWithTimestamp();
  
  return {
    "x-api-key": apiKey,
    "X-TIMESTAMP": customTimestamp,
  };
};
